<template>
  <v-row class="flex-column mt-6 pr-8">
    <v-col class="custom-panel">
      <v-row class="flex-column">
        <v-col class="custom-panel__header">
          Edit Tier
          <v-btn icon @click="$router.push('/tiers')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-col>
        <div v-if="loading" style="text-align:center; margin-top: 16px;">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
        <v-form v-show="!loading" v-model="valid" class="form-right-view-lable">
          <v-col class="custom-form mt-5">
            <v-row no-gutters>
              <v-col sm="2"
                ><label class="custom-form__label">Tier Name *</label></v-col
              >
              <v-col sm="8">
                <v-text-field
                  v-model="tierName"
                  :rules="NameRules"
                  filled
                  autofocus
                />
                
              </v-col>
              <v-col sm="1" v-if="isCustom">
                <v-checkbox
                  class="custom-form__label ml-9 pl-9"
                  label="Custom Tier"
                  v-model="isCustom"
                  readonly
                >
                </v-checkbox>
              </v-col>
            </v-row>
            <v-row no-gutters v-if="isCustom">
              <v-col sm="2">
                <label class="custom-form__label">Select Customer</label>
              </v-col>
              <v-col sm="8">
                <v-select
                v-model="Customer"
                :item-text="(item) => item.name" 
                :items="CustomersList" 
                :item-value="(item) => item.id"
                readonly
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col sm="2"
                ><label class="custom-form__label">Description *</label></v-col
              >
              <v-col sm="8">
                <v-text-field
                  v-model="tierDescription"
                  :rules="descriptionRules"
                  filled
                />
              </v-col>
            </v-row>
            <!-- <v-row no-gutters>
              <v-col sm="2">
                <label class="custom-form__label">Tools Integration</label>
              </v-col>
              <v-col sm="8">
                <v-select
                  v-model="toolsIntegration"
                  :item-text="(item) => item.domainName"
                  :items="domainList"
                  :item-value="(item) => item.id"
                  append-icon="expand_more"
                  attach
                ></v-select>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col sm="2">
                <label class="custom-form__label">Refresh Rate</label>
              </v-col>
              <v-col sm="8">
                <v-select
                  v-model="refreshRate"
                  :item-text="(item) => item.domainName"
                  :items="domainList"
                  :item-value="(item) => item.id"
                  append-icon="expand_more"
                  attach
                ></v-select>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col sm="2">
                <label class="custom-form__label">Space</label>
              </v-col>
              <v-col sm="8">
                <v-select
                  v-model="space"
                  :item-text="(item) => item.domainName"
                  :items="domainList"
                  :item-value="(item) => item.id"
                  append-icon="expand_more"
                  attach
                ></v-select>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col sm="2">
                <label class="custom-form__label">Data Archive</label>
              </v-col>
              <v-col sm="8">
                <v-select
                  v-model="dataArchive"
                  :item-text="(item) => item.domainName"
                  :items="domainList"
                  :item-value="(item) => item.id"
                  append-icon="expand_more"
                  attach
                ></v-select>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col sm="2"
                ><label class="custom-form__label">Duration *</label></v-col
              >
              <v-col sm="4">
                <v-text-field v-model="tierDays" :rules="daysRules" filled />
              </v-col>
              <v-col sm="2"
                ><label class="custom-form__label ml-3">Days</label></v-col
              >
            </v-row> -->
            <v-row no-gutters>
              <v-col sm="2">
                <label class="custom-form__label">Tools Integration *</label>
              </v-col>
              <v-col sm="4">
                <v-select
                  v-model="toolsIntegration"
                  :items="toolsData"
                  :item-value="(item) => item.value"
                  append-icon="expand_more"
                  attach
                ></v-select>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col sm="2">
                <label class="custom-form__label">Refresh Rate *</label>
              </v-col>
              <v-col sm="4">
                <v-select
                  v-model="refreshRate"
                  :items="refreshData"
                  :item-value="(item) => item.value"
                  append-icon="expand_more"
                  attach
                ></v-select>
              </v-col>
              <v-col sm="2">
                <label class="custom-form__label ml-9 pl-9">Type</label>
              </v-col>
              <v-col sm="2">
                <v-select
                  v-model="refreshRateTypeData"
                  :items="refreshRateType"
                  :item-value="(item) => item.value"
                  append-icon="expand_more"
                  attach
                ></v-select>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col sm="2">
                <label class="custom-form__label">Space *</label>
              </v-col>
              <v-col sm="4">
                <v-select
                  v-model="space"
                  :items="spaceData"
                  :item-value="(item) => item.value"
                  append-icon="expand_more"
                  attach
                ></v-select>
              </v-col>
              <v-col sm="2">
                <label class="custom-form__label ml-9 pl-9">Units</label>
              </v-col>
              <v-col sm="2">
                <v-select
                  v-model="spaceTypeData"
                  :items="spaceType"
                  :item-value="(item) => item.value"
                  append-icon="expand_more"
                  attach
                ></v-select>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col sm="2">
                <label class="custom-form__label">Data Archive *</label>
              </v-col>
              <v-col sm="4">
                <v-select
                  v-model="dataArchive"
                  :items="archiveData"
                  :item-value="(item) => item.value"
                  append-icon="expand_more"
                  attach
                ></v-select>
              </v-col>
              <v-col sm="2">
                <label class="custom-form__label ml-9 pl-9"
                  >Archive Duration</label
                >
              </v-col>
              <v-col sm="2">
                <v-select
                  v-model="archiveDataType"
                  :items="archiveTypeDuration"
                  :item-value="(item) => item.value"
                  append-icon="expand_more"
                  attach
                ></v-select>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col sm="2"
                ><label class="custom-form__label">Duration *</label></v-col
              >
              <v-col sm="4">
                <v-select
                  v-model="tierDays"
                  :rules="daysRules"
                  :items="durationData"
                  :item-value="(item) => item.value"
                  append-icon="expand_more"
                  attach
                />
              </v-col>
              <v-col sm="2"
                ><label class="custom-form__label ml-9 pl-9"
                  >Duration Type</label
                ></v-col
              >
              <v-col sm="2">
                <v-select
                  v-model="durationDefault"
                  :items="durationType"
                  :item-value="(item) => item.value"
                  append-icon="expand_more"
                  attach
                ></v-select>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col sm="2"
                ><label class="custom-form__label mt-1"
                  >Products Included *</label
                ></v-col
              >
              <v-col sm="8">
                <v-checkbox
                  v-for="(product, i) in tiers"
                  :key="i"
                  v-model="product.check"
                  :label="product.productName"
                  >{{ product.productName }}
                </v-checkbox>
              </v-col>
            </v-row>
            <v-row v-for="(product, i) in tiers" :key="i" no-gutters>
              <v-col v-if="product.check" sm="2"
                ><label
                  class="custom-form__label"
                  filled
                  :label="product.productName"
                  ># of users in {{ product.productName }} *
                </label></v-col
              >
              <v-col v-if="product.check" sm="1">
                <v-text-field
                  v-model="product.noOfUsers"
                  :rules="NoOfUsers"
                  filled
                />
              </v-col>
              <v-col v-if="product.check" offset-sm="1" sm="2">
                <label
                  class="custom-form__label"
                  filled
                  :label="product.licenseFee"
                  >License Cost per user
                </label>
              </v-col>
              <v-col v-if="product.check" sm="1">
                <v-text-field
                  v-model="product.licenseFee"
                  :rules="licenseFee"
                  filled
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col sm="2">
                <label class="custom-form__label">Number Of Test Execution Cycles</label>
              </v-col>
              <v-col sm="4">
                <v-text-field
                v-model="noOfTestExec"
                  filled
                  autofocus
                  @keydown="updated($event)"
                   @keypress="isNumber($event)"
                />
              </v-col>
              <v-col sm="2">
                <label class="custom-form__label ml-9 pl-9">Number Of Devices</label>
              </v-col>
              <v-col  sm="1">
                <v-text-field
                v-model="noOfDevices"
                  filled
                  autofocus
                  @keydown="updated($event)"
                   @keypress="isNumber($event)"
                />
              </v-col>
              <v-col sm="2">
                <label class="custom-form__label ml-9 pl-9">Number Of Labs</label>
              </v-col>
              <v-col  sm="1">
                <v-text-field
                v-model="noOfLabs"
                  filled
                  autofocus
                  @keydown="updated($event)"
                   @keypress="isNumber($event)"
                />
              </v-col>
            </v-row>
            <font color="red" class="v-virtual-table">{{ text }}</font>
            <v-row>
              <v-col class="text-center">
                <v-btn
                  :disabled="!valid || buttonCheck() || saveBtnloading"
                  class="primary_btn small"
                  depressed
                  :loading="saveBtnloading"
                  @click="updateTierData"
                  >Save</v-btn
                >
              </v-col>
            </v-row>
          </v-col>
        </v-form>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { storeActions } from '@/store/actions.constants';

export default {
  data() {
    return {
      isCustom:null,
      loading: true,
      saveBtnloading: false,
      valid: false,
      Customer:'',
      items: [],
      tierName: '',
      tierData: [],
      tierDescription: '',
      selectedProducts: [],
      numberOfTedUsers: '',
      costForTedUser: '',
      numberOfPaceUsers: '',
      costForPaceUser: '',
      numberOfMobeUsers: '',
      costForMobeUser: '',
      tierObj: {},
      tierDays: null,
      toolsIntegration: '',
      noOfDevices:'',
      noOfLabs:'',
      noOfTestExec:'',
      CustomersList:[],
      refreshRate: '',
      space: '',
      
      dataArchive: null,
      invalidChars: ['-', '+', 'e', '.'],
      durationData: ['15', '1'],
      toolsData: ['1-5', '6-10', 'Unlimited'],
      refreshData: ['5', '10', 'Unlimited'],
      refreshRateTypeData: 'week',
      refreshRateType: ['days', 'week', 'month'],
      spaceData: ['2', '5', '10'],
      spaceTypeData: '',
      spaceType: ['GB', 'TB'],
      archiveData: ['30', '60', '90', '120'],
      archiveDataType: 'days',
      archiveTypeDuration: ['days','weeks', 'months', 'year'],
      durationDefault: '',
      durationType: ['days', 'year'],
      NameRules: [
        (v) => !!v?.trim() || 'Tier Name is required',
        (v) =>
          /^[A-Za-z_ ]{3,20}$/.test(v?.trim()) ||
          'Name should contain character only and length should be 3 to 20',
      ],
      daysRules: [
        (v) => !!v || 'Duration required in number of days.',
        (v) => /^[\d]*$/.test(v) || 'Only positive numbers are allowed.',
        (v) => (v > 0 && v <= 365) || 'Number of days must be 1 to 365.',
      ],
      NoOfUsers: [
        (v) => !!v || 'No. of users required',
        (v) => /^[\d]*$/.test(v) || 'Only positive numbers are allowed.',
        (v) => v > 0 || 'Only positive numbers are allowed.',
      ],
      licenseFee: [
        // (v) => !!v || 'License fee required',   //Since we sholud able to create license with default 0 price
        (v) =>
          /^(\$|)([0-9]\d{0,2}(\,\d{3})*|([0-9]\d*))(\.\d{2})?$/.test(v) ||
          'Invalid Price',
        (v) => v >= 0 || 'Only positive numbers are allowed.',
      ],
      descriptionRules: [
        (val) => !!val.trim() || 'Description is required.',
        (val) =>
          val.trim().length <= 100 ||
          'Description should not be more than 100 character.',
      ],
      text: '',
      check: false,
      tierList: [],
      products: [],
      productUsers:[],
    };
  },
  computed: {
    ...mapGetters({
      tiersData: 'tiers/getTier',
    }),
    tiers() {
      return this.tierList;
    },
  },
  async mounted() {
    console.log(this.tiersData);
    this.products = await this.getProducts();
    console.log('products valye',this.products.data)
    let id = this.$route.params.id;
    await this.getTierData(id);
    let res = await this.getListOfCustomers();
    this.CustomersList = res.data;
    let response= await this.getTierById(id);
    console.log("usshshsdhdh",response.data);
  },
  methods: {
    ...mapActions({
      updateTier: 'tiers/updateTier',
      getTierById: 'tiers/getTierById',
      getProducts: 'tiers/getProductList',
      getListOfCustomers:'tiers/getListOfCustomers'
    }),
    buttonCheck() {
      if (
        this.tierName == null ||
        this.tierName === '' ||
        this.tierDescription == null ||
        this.tierDescription === '' ||
        this.tierDays === null ||
        this.toolsIntegration === null ||
        this.refreshRate === null ||
        this.space === null ||
        this.dataArchive === null ||
        this.tiers.filter((el) => el.check === true).length === 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    getTierData(id) {
      this.loading = true;
      let tierObj = {
        tier_id: id,
      };
      this.getTierById(tierObj)
        .then((res) => {
          console.log("resulted data",res.data);
          this.tierName = res.data.tierName;
          this.tierDescription = res.data.description;
          this.toolsIntegration = res.data.noOfTools;
          this.noOfDevices = res.data.noOfDevices;
          this.noOfLabs= res.data.noOfLabs;
          this.noOfTestExec = res.data.noOfTestExec;
          this.isCustom=res.data.isCustom;
          this.Customer=res.data.customerId;
          if (this.toolsIntegration === 5) {
            this.toolsIntegration = this.toolsData[0];
          } else if (this.toolsIntegration === 6) {
            this.toolsIntegration = this.toolsData[1];
          } else if (this.toolsIntegration === -1) {
            this.toolsIntegration = 'Unlimited';
          }
          this.refreshRate = res.data.refreshRate;
          if (this.refreshRate === '-1') {
            this.refreshRate = 'Unlimited';
          }
          this.space = res.data.space;
          if(this.space === '-1') {
            this.space = '1'
          }
          this.spaceTypeData = res.data.spaceType;
          this.durationDefault = res.data.durationType
          this.dataArchive = res.data.dataArchive;
          if(res.data.dataArchive ===1){
            this.dataArchive = this.archiveData[0]
          } 
          else if(res.data.dataArchive === 2) {
            this.dataArchive = this.archiveData[1]
          }
          else if(res.data.dataArchive === 3) {
            this.dataArchive = this.archiveData[2]
          }
          else if(res.data.dataArchive === 6) {
            this.dataArchive = this.archiveData[3]
          }
          this.archiveDataType = res.data.dataArchiveType
          this.tierDays = res.data.noOfDays;
          if(res.data.noOfDays === 15) {
            this.tierDays = this.durationData[0]
          } else {
            this.tierDays = this.durationData[1]
          }
          this.tierData = res.data.products;
          this.tierList = this.products.data
            .map((el) => {
              let tiers = this.tierData
                .filter((tier) => tier.productId === el.id)
                .map((tier) => ({
                  productId: el.id,
                  productName: el['productName'],
                  check: true,
                  licenseFee: tier.licenseFee,
                  noOfUsers: tier.noOfUsers,
                }));
              if (tiers.length < 1) {
                tiers.push({
                  productId: el.id,
                  productName: el['productName'],
                  check: false,
                  licenseFee: 0,
                  noOfUsers: 0,
                });
              }
              return tiers;
            })
            .flat();
        })
        .catch((err) => {
          this.text = err.message;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async updateTierData() {
      this.saveBtnloading = true;
      if(this.refreshRate === 'Unlimited') {
        this.refreshRate = -1;
      }
      if (this.toolsIntegration === this.toolsData[2]) {
        this.toolsIntegration = -1;
      } else if(this.toolsIntegration === this.toolsData[0]) {
        this.toolsIntegration = 5
      } else if(this.toolsIntegration === this.toolsData[1]) {
        this.toolsIntegration = 6
      }
      this.tierObj = await this.updateTier({
        tierId: this.$route.params.id,
        tierName: this.tierName,
        days: this.tierDays,
        description: this.tierDescription,
        noOfTools: this.toolsIntegration,
        refreshRate: this.refreshRate,
        refreshRateType: this.refreshRateTypeData,
        space: this.space,
        spaceType: this.spaceTypeData,
        dataArchive: this.dataArchive,
        dataArchiveType: this.archiveDataType,
        durationType: this.durationDefault,
        products: this.tiers.filter((el) => el.check === true),
        noOfDevices:parseInt(this.noOfDevices),
        noOfLabs:parseInt(this.noOfLabs),
        noOfTestExec:parseInt(this.noOfTestExec),
        isCustom:this.isCustom,
        customerId:this.Customer
      });
      if (this.tierObj.status === 200 || this.tierObj.status === 201) {
        this.saveBtnloading = false;
        this.$router.push('/tiers');
        this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
          text: 'Tier Updated Successfully',
          timeout: 1000,
          color: 'success',
        });
      } else {
        this.saveBtnloading = false;
        this.text = this.tierObj.data.message;
      }
    },
    isNumber(evt) {
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      }
    },
    updated(val) {
      if (this.invalidChars.includes(val.key)) val.preventDefault();
    },
  },
};
</script>
